export default function($element, $message, opts, callbacks, sortable, curFile) {
  var defaults = _.extend({}, Kadenze.DropzoneDefaults, {
    url: Kadenze.Routes.attachments_path(),
    addRemoveLinks: false,
    dictRemoveFile: '',
    autoProcessQueue: false,
    maxFiles: 30,
    maxFilesize: 100,
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    sortItems: '.tr',
    sortHandle: '.action-btn--move',
    sortNumber: '.in-table__order-num',
    // acceptedFiles: ".jpeg,.jpg,.png,.gif,.JPEG,.JPG,.PNG,.GIF",
    // previewsContainer: previewArea,
    previewTemplate: opts.previewTemplate || Kadenze.I18n.tt(JST['templates/dropzone-generic-media-preview']({ previewable: opts.previewable, playable: opts.playable })),
    videoPreviewTemplate: Kadenze.I18n.tt(JST['templates/dropzone-resource-preview']()),
    useKilobytes: true, // custom option added to dropzone. Contacting dev to see if they'll add this feature

    init: function() {
      this.on('thumbnail', function(file, data) {
        console.log('dz.on(\'thumbnail\')');

        if (callbacks.thumbnail) {
          callbacks.thumbnail(file, data);
        }
        if (this.options.cropOptions) {
          if (!file.cropped) {
            var fileType = '.'+file.type.split('/')[1];
            var acceptedFilesArray = this.options.acceptedFiles.split(/,\s*/);
            if(_.contains(acceptedFilesArray, fileType)){
              Kadenze.DropzoneUtils.showCropper(this, this.options.cropOptions);
            }
          }
        }
      });

      this.on('sending', function(file, xhr, formData) {
        console.log('dz.on(\'sending\')');

        if (callbacks.sending) {
          callbacks.sending(file, xhr, formData);
        }
      });

      this.on('sendingmultiple', function(file, xhr, formData) {
        console.log('dz.on(\'sendingmultiple\')');

        if (callbacks.sendingmultiple) {
          callbacks.sendingmultiple(file, xhr, formData);
        }
      });

      this.on('success', function(file, response) {
        console.log('dz.on(\'success\')');
        $(file.previewTemplate).find('.dz-progress').hide();

        if (callbacks.success) {
          callbacks.success(file, response);
        }

        if(opts.previewable && file.type.match(/image/i)) {
          Kadenze.DropzoneUtils.initImagePreview(this, file, response.files[0].url, opts.dzName);
        }

        if(opts.playable && file.type.match(/audio/i)) {
          Kadenze.DropzoneUtils.initAudioPreview(this, file, response.files[0], opts.dzName);
        }

        if (sortable == true) {
          console.log('Sortable', dzOptions.previewsContainer);
          $(dzOptions.previewsContainer).sortable({
            items: dzOptions.sortItems,
            handle: dzOptions.sortHandle,
            helper: function(e, ui) {
              ui.children().each(function() {
                $(this).width($(this).width());
              });
              return ui;
            },
            update: function(e, ui) {
              updateOrderNumber($(this));
              if (callbacks.sortableUpdate) {
                callbacks.sortableUpdate(e, ui);
              }
            },
            sort: function(event, ui) {
              $(ui.item).css({
                //marginTop: $(window).scrollTop() + 'px'
              });
            },
            beforeStop: function(event, ui) {
              $(ui.item).css({
                //marginTop: '20px'
              });
            }
          });
        }
      });

      this.on('successmultiple', function(file, response) {
        console.log('dz.on(\'successmultiple\')');

        if (callbacks.successmultiple) {
          callbacks.successmultiple(file, response);
        }
      });

      this.on('uploadprogress', function(file, progress, bytesSent) {
        console.log('dz.on(\'uploadprogress\')', file.size, progress, bytesSent);
        if (callbacks.uploadprogress) {
          callbacks.uploadprogress(file, progress, bytesSent);
        }
      });

      this.on('totaluploadprogress', function(progress) {
        console.log('dz.on(\'totaluploadprogress\')', progress);
        if (callbacks.totaluploadprogress) {
          callbacks.totaluploadprogress(progress);
        }
      });

      this.on('error', function(file, errorMessage) {
        console.log('dz.on(\'error\')', errorMessage);
        if (callbacks.error) {
          callbacks.error(file, errorMessage);
        }
      });

      //TODO: Remove one of these duplicate listeners
      this.on('maxfilesexceeded', function(file){
        if (callbacks.maxfilesexceeded) {
          callbacks.maxfilesexceeded(file);
        } else {
          console.log('MediaDropZone: about to remove files and add file...');
          this.removeAllFiles();
          this.addFile(file);
        }
      });

      this.on('complete', function(file) {
        console.log('dz.on(\'complete\')');
        $(file.previewTemplate).find('.dz-progress').hide();

        if (callbacks.complete) {
          callbacks.complete(file);
        }

        $('.js-dz-show-on-complete').show();
      });

      this.on('completemultiple', function(file) {
        console.log('dz.on(\'completemultiple\')');

        if (callbacks.completemultiple) {
          callbacks.completemultiple(file);
        }
      });

      this.on('canceled', function(file) {
        console.log('dz.on(\'canceled\')');
        $('.dz-img__progress_holder', $el).hide();
        if (callbacks.canceled) {
          callbacks.canceled(file);
        }
      });

      this.on('drop', function(file) {
        console.log('dz.on(\'drop\')');
        if (callbacks.drop) {
          callbacks.drop(file);
        }
      });

      //TODO: Remove one of these duplicate listeners
      this.on('maxfilesexceeded', function(file) {
        console.log('dz.on(\'maxfilesexceeded\')');
        if (callbacks.maxfilesexceeded) {
          callbacks.maxfilesexceeded(file);
        }
      });

      this.on('addedfile', function(file, data) {
        console.log('dz.on(\'addedfile\')');

        setupPreviewState(file);

        if (sortable == true) {
          updateOrderNumber($(dzOptions.previewsContainer));
        }

        if (callbacks.addedfile) {
          callbacks.addedfile(file);
        }
      });

      this.on('removedfile', function(file) {
        console.log('dz.on(\'removedfile\')');
        if (sortable == true) {
          updateOrderNumber($(dzOptions.previewsContainer));
        }
        if (callbacks.removedfile) {
          callbacks.removedfile(file);
        }
      });


    }
  });

  var $el = $($element);
  $el.addClass('dz-unit');
  $el.append($message);
  var id = $el.attr('id') ? $el.attr('id') : '';

  var dzOptions = _.extend({},defaults, opts);
  this.dropzone = new Dropzone('div#' + id, dzOptions);

  var updateOrderNumber = function($container) {
    $container.find( dzOptions.sortItems ).each(function() {
      $(this).find(dzOptions.sortNumber).text($(this).index() + 1);
      console.log('updateOrderNumber', $(this).index() + 1);
    });
  };

  var setupPreviewState = function(file) {
    $(file.previewTemplate).addClass('dz-preview-type--' + file.type.split('/')[0]);
  };



  if ( curFile && curFile.path ) {
    var fileObj = {
      name: curFile.name || '',
      size: curFile.size || 0,
      title: curFile.title || 0,
      status: 'success',
      type: curFile.type || ''
    };
    var thumbPath;
    if(curFile.type === 'image'){
      thumbPath = curFile.path;
    } else {
      thumbPath = '';
    }
    this.dropzone.emit('addedfile', fileObj);
    this.dropzone.emit('thumbnail', fileObj, thumbPath);
    this.dropzone.emit('complete', fileObj);
    this.dropzone.files.push( fileObj );
  }

  return this.dropzone;
}
